import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("vd_token");
    if (!token) {
      setUser(null); setMember(null); setLoading(false); return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
      setMember(r.data.member);
    } catch {
      localStorage.removeItem("vd_token");
      setUser(null); setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // M2: password login is gone. Admin sessions arrive via the Foundry SSO
  // handoff — /sso reads the token fragment and exchanges it here.
  const ssoExchange = async (handoffToken) => {
    const r = await api.post("/auth/sso/exchange", { token: handoffToken });
    localStorage.setItem("vd_token", r.data.token);
    setUser(r.data.user);
    await refresh();
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("vd_token");
    setUser(null); setMember(null);
  };

  return (
    <AuthContext.Provider value={{ user, member, loading, ssoExchange, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
